<template>
	<div
		class="product-info"
		@click="productClick"
	>
		<img class="product-icon" v-lazy="item.goods_img_480"/>
		<div class="productContent">
			<span class="product-title">{{ item.goods_name }}</span>
			<div class="product-bottom">
				<span class="product-price">$<i class="price">{{ item.goods_promotion_price }}</i></span>
				<span class="product-buy">Sold {{ item.goods_salenum }} item(s)</span>
			</div>	
		</div>
		
	</div>
</template>

<script>
export default {
  name: 'IndexProductBody',
  data () {
    return {
      itemWidth: 0,
      itemHeight: 0,
      showRightBorder: this.index % 2 == 0
    }
  },
  props: ['item', 'index'],
  computed: {

  },
  methods: {
    productClick: function () {
      this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: this.item.goods_id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.border {
	border-right: 1px solid #f5f5f5;
}
.product-info {
	display: flex;
	flex-direction: column;
	overflow: hidden;
	padding:0.5rem;
	justify-content: flex-end;
	width:50%;box-sizing:border-box;
	.product-icon {
		align-self: center;
		width:100%;box-sizing:border-box;
	}
	.product-title {
		color: #333;
		font-size: .7rem;
		line-height:1rem;
		height:2rem;
		margin-top: 0.4rem;
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
	.product-bottom {
		display: flex;
		justify-content: space-between;
		margin-top:.4rem;
		line-height:1rem;
		.product-price {
			color: $primaryColor;
			font-size:.65rem;
      .price{font-size:.8rem}
		}
		.product-buy {
			color: #999999;
			font-size:.65rem;
		}
	}
}
body .productContent{padding: 0.3rem;padding-top: 0rem;}
</style>
